import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { GlobalProductService } from 'src/app/services/global-product.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-csv-import-dialog',
  templateUrl: './csv-import-dialog.component.html',
  styleUrls: ['./csv-import-dialog.component.scss']
})
export class CsvImportDialogComponent {
  @Input() chainId: string | null = null;

  selectedFile: File | null = null;
  importing = false;
  result: any = null;
  errorMsg: string = '';

  csvColumns = [
    'Product name*', 'Barcode', 'SKU', 'Description', 'Image URL',
    'Weight (g)', 'Length (mm)', 'Width (mm)', 'Height (mm)',
    'Age Restricted', 'Minimum Age', 'Has Deposit', 'Deposit Category',
    'Provider Deposit Code', 'Tags', 'Meta Title', 'Meta Description',
    'Main Group', 'Product Group', 'Sub Group', 'DSK Assortment ID', 'Family', 'Discount Group', 'Global Category',
    'Default Cost Price', 'Default Sell Price'
  ];

  constructor(
    private dialogRef: NbDialogRef<CsvImportDialogComponent>,
    private globalProductService: GlobalProductService,
    private toastr: ToastrService
  ) {}

  onFileSelect(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;
    if (!file.name.endsWith('.csv')) {
      this.errorMsg = 'Please select a CSV file (.csv)';
      this.selectedFile = null;
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      this.errorMsg = 'File must be under 10MB';
      this.selectedFile = null;
      return;
    }
    this.selectedFile = file;
    this.errorMsg = '';
    this.result = null;
  }

  downloadTemplate(): void {
    this.globalProductService.downloadTemplate().subscribe({
      error: (err: any) => {
        const message = err?.error?.response?.message || err?.message || 'Template download failed';
        this.errorMsg = message;
        this.toastr.error(message);
      }
    });
  }

  import(): void {
    if (!this.selectedFile) return;
    this.importing = true;
    this.errorMsg = '';
    const formData = new FormData();
    formData.append('csvFile', this.selectedFile);

    const obs$ = this.chainId
      ? this.globalProductService.importChainCSV(this.chainId, formData)
      : this.globalProductService.importPlatformCSV(formData);

    obs$.subscribe({
      next: (res: any) => {
        this.importing = false;
        this.result = res?.response?.data || res?.data || res;
      },
      error: (err: any) => {
        this.importing = false;
        this.errorMsg = err?.error?.response?.message || 'Import failed. Please try again.';
      }
    });
  }

  close(): void {
    this.dialogRef.close(this.result !== null);
  }
}
